import {VehicleTypeEnum} from '@dms/api/vehicle';

export const isVanOrTruck = (vehicleType: VehicleTypeEnum) =>
  vehicleType === 'VEHICLETYPE_VAN' || vehicleType === 'VEHICLETYPE_TRUCK';
